const rankingItems = [
  {
    rank: 1,
    title: '长安诡事录',
    sub: '悬疑 · 古装',
    score: '9.6',
    hot: '152万热度',
    change: 'up',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mystery%20drama%20movie%20poster%2C%20dark%20palace%20atmosphere%20with%20lantern%20lights%2C%20traditional%20costume%20silhouette%20in%20fog%2C%20cinematic%20thriller%20style%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20film%20poster%20composition%2C%20high%20contrast%20dramatic%20lighting&width=400&height=560&seq=ranking-01-ancient-mystery&orientation=portrait',
  },
  {
    rank: 2,
    title: '星河纪元',
    sub: '科幻 · 冒险',
    score: '9.4',
    hot: '138万热度',
    change: 'up',
    img: 'https://readdy.ai/api/search-image?query=Science%20fiction%20space%20adventure%20movie%20poster%2C%20futuristic%20spaceship%20near%20nebula%2C%20astronaut%20looking%20at%20distant%20galaxy%2C%20epic%20cinematic%20composition%2C%20deep%20space%20blue%20and%20gold%20accents%2C%20clean%20movie%20poster%20style%20with%20dramatic%20lighting&width=400&height=560&seq=ranking-02-scifi-space&orientation=portrait',
  },
  {
    rank: 3,
    title: '烟火人家',
    sub: '家庭 · 温情',
    score: '9.3',
    hot: '121万热度',
    change: 'new',
    img: 'https://readdy.ai/api/search-image?query=Warm%20Chinese%20family%20drama%20movie%20poster%2C%20family%20gathering%20around%20dinner%20table%20with%20warm%20lighting%2C%20cozy%20home%20interior%2C%20emotional%20and%20heartfelt%20atmosphere%2C%20soft%20golden%20hour%20light%20streaming%20through%20windows%2C%20cinematic%20portrait%20style&width=400&height=560&seq=ranking-03-family-drama&orientation=portrait',
  },
  {
    rank: 4,
    title: '暗夜追踪',
    sub: '动作 · 犯罪',
    score: '9.1',
    hot: '109万热度',
    change: 'down',
    img: 'https://readdy.ai/api/search-image?query=Dark%20action%20crime%20thriller%20movie%20poster%2C%20rainy%20city%20street%20at%20night%20with%20neon%20reflections%2C%20mysterious%20figure%20in%20trench%20coat%2C%20noir%20cinematic%20style%2C%20deep%20shadows%20and%20vibrant%20neon%20accents%2C%20suspenseful%20moody%20atmosphere&width=400&height=560&seq=ranking-04-action-crime&orientation=portrait',
  },
  {
    rank: 5,
    title: '笑傲江湖录',
    sub: '武侠 · 古装',
    score: '8.9',
    hot: '98万热度',
    change: 'up',
    img: 'https://readdy.ai/api/search-image?query=Classic%20Chinese%20martial%20arts%20wuxia%20movie%20poster%2C%20warrior%20on%20mountain%20peak%20with%20flowing%20robes%2C%20misty%20landscape%20with%20pine%20trees%2C%20ink%20wash%20painting%20style%20composition%2C%20elegant%20traditional%20aesthetic%20with%20golden%20sunset%20light&width=400&height=560&seq=ranking-05-wuxia-martial&orientation=portrait',
  },
  {
    rank: 6,
    title: '青春不散场',
    sub: '校园 · 爱情',
    score: '8.7',
    hot: '87万热度',
    change: 'new',
    img: 'https://readdy.ai/api/search-image?query=Youth%20romance%20school%20drama%20movie%20poster%2C%20young%20couple%20under%20cherry%20blossom%20trees%2C%20sunlit%20campus%20pathway%2C%20fresh%20and%20warm%20spring%20atmosphere%2C%20nostalgic%20coming%20of%20age%20vibe%2C%20soft%20pastel%20color%20palette%20with%20gentle%20lighting&width=400&height=560&seq=ranking-06-youth-romance&orientation=portrait',
  },
  {
    rank: 7,
    title: '异兽觉醒',
    sub: '奇幻 · 冒险',
    score: '8.6',
    hot: '76万热度',
    change: 'up',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20adventure%20creature%20feature%20movie%20poster%2C%20mythical%20beast%20emerging%20from%20ancient%20forest%2C%20mystical%20glowing%20elements%2C%20epic%20fantasy%20cinematic%20style%2C%20dramatic%20moonlight%20and%20bioluminescence%2C%20grand%20scale%20composition&width=400&height=560&seq=ranking-07-fantasy-monster&orientation=portrait',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 gap-3">
          <div>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-1">
              热播排行榜
            </h2>
            <p className="text-sm text-foreground-500">全网热播好剧，实时排名更新</p>
          </div>
          <div className="flex items-center gap-3">
            <span className="px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium cursor-pointer whitespace-nowrap">本周</span>
            <span className="px-3 py-1.5 rounded-full bg-background-200/70 text-foreground-500 text-xs cursor-pointer whitespace-nowrap hover:bg-background-300/60 transition-colors">本月</span>
            <span className="px-3 py-1.5 rounded-full bg-background-200/70 text-foreground-500 text-xs cursor-pointer whitespace-nowrap hover:bg-background-300/60 transition-colors">全部</span>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="aspect-[2/3] w-full overflow-hidden">
                <img
                  src={item.img}
                  alt={`${item.title} - ${item.sub}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  title={`悟空影视热播排行榜第${item.rank}名：${item.title}`}
                  loading="lazy"
                />
                <div className="absolute top-2 left-2 w-7 h-7 flex items-center justify-center rounded-lg bg-background-50/90 backdrop-blur-sm text-xs font-bold text-foreground-900">
                  {item.rank}
                </div>
                {item.change === 'new' && (
                  <div className="absolute top-2 right-2 px-1.5 py-0.5 rounded bg-accent-500 text-background-50 text-[10px] font-semibold">
                    NEW
                  </div>
                )}
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.sub}</p>
                <div className="flex items-center justify-between mt-2">
                  <span className="flex items-center gap-1 text-xs text-accent-600 font-medium">
                    <i className="ri-star-fill text-[10px]"></i>
                    {item.score}
                  </span>
                  <span className="text-[10px] text-foreground-400">{item.hot}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}